import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LandmarkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PanelCard } from './PanelCard';
interface SinglePlanOfferProps {
  className?: string;
}
const inclusions = ['Página web profesional a medida', 'Carta digital clara y fácil de consultar', 'Diseño responsive para cada pantalla', 'Gestión y mantenimiento integral', 'Actualizaciones y soporte continuo', 'Sin cuotas ni costes ocultos'];
export function SinglePlanOffer({
  className = ''
}: SinglePlanOfferProps) {
  return <section className={`section-shell border-t border-white/10 bg-[#0a0a0a] ${className}`} aria-labelledby="offer-title" data-id="element-163" data-mp="1aw9t66pd5zja">
      <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-164" data-mp="16slmdq8k37z3">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-5xl" data-id="element-165" data-mp="2ma5l6g1da2rx">
          <PanelCard title="La base digital de tu negocio, en una sola propuesta." meta="La oferta" titleId="offer-title" data-id="element-166" data-mp="1ybx648ep0et2">
            <div className="grid lg:grid-cols-[1.15fr_0.85fr]" data-id="element-167" data-mp="16k7xt2z4j72y">
              <div className="px-6 py-8 sm:px-9 sm:py-10" data-id="element-168" data-mp="16hlgwcqcff82">
                <p className="max-w-xl text-[15px] leading-relaxed text-neutral-600" data-id="element-169" data-mp="1amba1ttmafpa">
                  Todo lo necesario para poner orden, elevar la percepción de tu
                  marca y facilitar que las personas adecuadas den el siguiente
                  paso.
                </p>
                <ul className="mt-7 grid gap-x-8 gap-y-3.5 border-t border-black/15 pt-6 sm:grid-cols-2" data-id="element-170" data-mp="mwgw18xkal3g">
                  {inclusions.map(inclusion => <li key={inclusion} className="flex gap-3 text-[13px] leading-relaxed text-neutral-700" data-id="element-171" data-mp="1v5pltw4m7lnr">
                      <CheckIcon size={15} className="mt-0.5 shrink-0 text-black" aria-hidden="true" data-id="element-172" data-mp="1q6cq0lvrn491" />
                      {inclusion}
                    </li>)}
                </ul>
              </div>
              <div className="flex flex-col justify-between border-t-2 border-black/15 px-6 py-8 sm:px-9 sm:py-10 lg:border-l-2 lg:border-t-0" data-id="element-173" data-mp="1c8ofa6vexdhp">
                <div data-id="element-174" data-mp="1l7rwt6exlku3">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500" data-id="element-175" data-mp="1l931r9k44yms">
                    Pago único
                  </p>
                  <p className="mt-4 text-6xl font-medium tracking-[-0.07em] text-black" data-id="element-176" data-mp="2wmf1b88uav35">
                    350 €
                  </p>
                  <p className="mt-2 text-[12px] font-medium uppercase tracking-[0.18em] text-neutral-500" data-id="element-177" data-mp="2rmsnoxp3nctt">
                    EUR
                  </p>
                  <p className="mt-4 text-[13px] leading-relaxed text-neutral-600" data-id="element-178" data-mp="345y0anyhayxd">
                    Importe por adelantado. Los impuestos aplicables se
                    calculan según el país de facturación y se muestran antes
                    de confirmar el pago. El proyecto comienza al confirmarse.
                  </p>
                </div>
                <div className="mt-9" data-id="element-179" data-mp="3ivvsrg3fyasd">
                  <p className="flex items-center gap-2 text-[12px] text-neutral-600" data-id="element-180" data-mp="3ntxbfzwyg83b">
                    <LandmarkIcon size={14} aria-hidden="true" data-id="element-181" data-mp="395akt21vntws" /> Pago online
                    seguro · Entrega estimada de 2 a 4 semanas
                  </p>
                  <Link to="/checkout" className="group mt-5 flex w-full items-center justify-center gap-2 bg-black px-5 py-4 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-182" data-mp="3e2svoxzggj7f">
                    Continuar al pago
                    <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-183" data-mp="2dzczocro6f5w" />
                  </Link>
                </div>
              </div>
            </div>
          </PanelCard>
        </motion.div>
      </div>
    </section>;
}